import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { create } from '../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const CreateEvent = ({ createEventModal, start, end, event, metadata, prefs, onModalCose }) => {
    const [formData, setFormData] = React.useState({
        campaign_id: '',
        start: start ? start.toISOString().slice(0, 16) : '',
        end: end ? end.toISOString().slice(0, 16) : '',
        recurrence: 'once'
    });

    React.useEffect(() => {
        if (start && end) {
            setFormData(prev => ({
                ...prev,
                start: start.toISOString().slice(0, 16),
                end: end.toISOString().slice(0, 16)
            }));
        }
    }, [start, end]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            await create('/admin/campaigns/scheduler/events', { data: formData });
            toast.success('Event created successfully');
            onModalCose();
        } catch (error) {
            toast.error('Error creating event: ' + error.message);
        }
    };

    const handleClose = () => {
        setFormData({
            campaign_id: '',
            start: '',
            end: '',
            recurrence: 'once'
        });
        onModalCose();
    };

    return (
        <Modal show={createEventModal} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Create Campaign Event</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Campaign</Form.Label>
                                <Form.Select
                                    name="campaign_id"
                                    value={formData.campaign_id}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Select a campaign</option>
                                    {Object.entries(metadata?.campaigns || {}).map(([id, name]) => (
                                        <option key={id} value={id}>{name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Recurrence</Form.Label>
                                <Form.Select
                                    name="recurrence"
                                    value={formData.recurrence}
                                    onChange={handleInputChange}
                                >
                                    <option value="once">Once</option>
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Start Date & Time</Form.Label>
                                <Form.Control
                                    type="datetime-local"
                                    name="start"
                                    value={formData.start}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>End Date & Time</Form.Label>
                                <Form.Control
                                    type="datetime-local"
                                    name="end"
                                    value={formData.end}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit">
                        Create Event
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default CreateEvent;
